var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"eb851d5c913313de8a2204e669c5ddbca230220a"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["ambii-patient@ambii-tw"]={id:"eb851d5c913313de8a2204e669c5ddbca230220a"};
      